import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { concatMap, catchError, map, switchMap, tap } from 'rxjs/operators';

import { DepartamentsBusinessColor } from '@app/models/departamentsBusinessColor';
import { DepartamentsBusinessColorService } from '@app/services/api/departaments-business-color.service';
import { FlashService } from '@app/services/flash.service';

import {
  DepartamentsBusinessColorActionTypes,
  Load,
  LoadSuccess,
  LoadFail,
  Create,
  CreateSuccess,
  CreateFail,
  AddOne,
  AddAll,
  Update,
  UpdateFail,
  UpdateSuccess,
  UpdateOne,
  Delete,
  DeleteSuccess,
  DeleteFail
} from '@core/actions/departaments-business-color.actions';

@Injectable()
export class DepartamentsBusinessColorEffects {
  @Effect()
  load$: Observable<Action> = this.actions$.pipe(
    ofType(DepartamentsBusinessColorActionTypes.Load),
    switchMap(() =>
      this.Api.get().pipe(
        map(
          (departamentsBusinessColor: DepartamentsBusinessColor[]) =>
            new LoadSuccess(departamentsBusinessColor)
        ),
        catchError(error => of(new LoadFail(error)))
      )
    )
  );

  @Effect()
  loadSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<LoadSuccess>(DepartamentsBusinessColorActionTypes.LoadSuccess),
    map(action => new AddAll(action.departamentsBusinessColor))
  );

  // @Effect()
  // loadOne$: Observable<Action> = this.actions$.pipe(
  //   ofType<LoadSingle>(DepartamentsBusinessColorActionTypes.LoadSingle),
  //   map(action => action.id),
  //   switchMap(id => {
  //     return this.retroplanningApi.getOne(id).pipe(
  //       map(retroplannings => new LoadSingleSuccess(retroplannings)),
  //       catchError(error => of(new LoadSingleFail(error)))
  //     );
  //   })
  // );

  // @Effect()
  // LoadSingleSuccess$: Observable<Action> = this.actions$.pipe(
  //   ofType<LoadSingleSuccess>(DepartamentsBusinessColorActionTypes.LoadSingleSuccess),
  //   map(action => new AddOne(action.data))
  // );

  @Effect()
  create$: Observable<Action> = this.actions$.pipe(
    ofType<Create>(DepartamentsBusinessColorActionTypes.Create),
    switchMap(action =>
      this.Api.create(action.departamentsBusinessColor).pipe(
        map(
          (savedColor: { message: string; data: DepartamentsBusinessColor }) =>
            new CreateSuccess(savedColor.data)
        ),
        catchError(error => of(new CreateFail(error)))
      )
    )
  );

  @Effect()
  createSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<CreateSuccess>(DepartamentsBusinessColorActionTypes.CreateSuccess),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Color Asignado' });
      return new AddOne(action.departamentsBusinessColor);
    })
  );

  @Effect({ dispatch: false })
  createFailFail$ = this.actions$.pipe(
    ofType<CreateFail>(DepartamentsBusinessColorActionTypes.CreateFail),
    map(action => action.error),
    tap(res =>
      this.fs.emit({
        message: res.error.message
          ? res.error.message
          : 'No se pudo asignar el color',
        type: 'danger'
      })
    )
  );

  @Effect()
  Delete$: Observable<Action> = this.actions$.pipe(
    ofType<Delete>(DepartamentsBusinessColorActionTypes.Delete),
    map(action => [action.id]),
    switchMap(([id]) => {
      return this.Api.delete(id).pipe(map(() => new DeleteSuccess(id)));
    })
  );

  @Effect()
  DeleteSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<DeleteSuccess>(DepartamentsBusinessColorActionTypes.DeleteSuccess),
    map(action => {
      this.fs.emit({
        type: 'success',
        message: 'Color Eliminado Correctamente'
      });
      return new Load();
    })
  );

  @Effect()
  update$: Observable<Action> = this.actions$.pipe(
    ofType<Update>(DepartamentsBusinessColorActionTypes.Update),
    map(action => [action.id, action.departamentsBusinessColor]),
    switchMap(([id, departamentsBusinessColor]) => {
      return this.Api.update(id, departamentsBusinessColor).pipe(
        map(
          (departamentsBusinessColor: DepartamentsBusinessColor) =>
            new UpdateSuccess(
              departamentsBusinessColor.id,
              departamentsBusinessColor
            )
        ),
        catchError(error => of(new UpdateFail(error)))
      );
    })
  );

  @Effect()
  updateSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<UpdateSuccess>(DepartamentsBusinessColorActionTypes.UpdateSuccess),
    map(action => {
      this.fs.emit({
        type: 'success',
        message: 'Color actualizado exitosamente'
      });
      return new UpdateOne(action.data.data);
    })
  );

  @Effect({ dispatch: false })
  updateFail$ = this.actions$.pipe(
    ofType<UpdateFail>(DepartamentsBusinessColorActionTypes.UpdateFail),
    map(action => action.error),
    tap(res => {
      this.fs.emit({
        message: res.error.message
          ? res.error.message
          : 'No es posible actualizar',
        type: 'danger'
      });
      return res.error;
    })
  );

  constructor(
    private actions$: Actions,
    private Api: DepartamentsBusinessColorService,
    private fs: FlashService,
    private router: Router
  ) {}
}
